import React from 'react';
import styles from './Buysamp.module.css';
import { FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const AllProducts = () => {
    const navigate = useNavigate();
    
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.illustration}>
                    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                        <path fill="#F0F0F0" d="M40,-70.8C50.6,-62.4,57.1,-49.1,65.6,-36.3C74.1,-23.5,84.6,-11.2,85.2,0.4C85.8,12,76.5,24,64.7,33.6C52.9,43.2,38.6,50.4,23.9,56.3C9.2,62.2,-5.9,66.8,-18.5,62.8C-31.1,58.8,-41.3,46.2,-50.2,33.3C-59.1,20.3,-66.8,7,-68.3,-7.8C-69.8,-22.6,-65.2,-38.9,-54.8,-48.1C-44.4,-57.3,-28.2,-59.4,-13.9,-67.5C0.4,-75.6,12.8,-89.7,40,-70.8Z" transform="translate(100 100)" />
                    </svg>
                </div>
                <h1 className={styles.title}>No Products Found</h1>
                <p className={styles.message}>It looks like there are no products available at the moment.</p>
                <button
                    className={styles.backButton}
                    onClick={() => navigate(window.history.length <= 2 ? '/' : -1)}
                >
                    <FiArrowLeft className={styles.buttonIcon} /> Back to Products
                </button>
            </div>
        </div>
    );
};

export default AllProducts;